import { useCallback } from 'react'

import { useMarkAllInAppNotificationsReadMutation } from '~/data/api/client/workflows'

/**
 * Clears every unread notification at once and resolves to how many were
 * cleared. The mutation invalidates the list tags, so the rows and the badge
 * refetch. Rejects on failure, leaving the caller to report it.
 */
export default function useMarkAllNotificationsRead() {
  const [markAllInAppRead, markAllInApp] = useMarkAllInAppNotificationsReadMutation()

  const markAllRead = useCallback(async () => {
    const { updated } = await markAllInAppRead().unwrap()
    return updated
  }, [markAllInAppRead])

  return { markAllRead, isLoading: markAllInApp.isLoading }
}
